<!-- Details-Dialog for the organisation -->
<p-dialog [header]="i18n?.i18nLng()['PAYMENTTYPES']"
          [modal]="true"
          [(visible)]="showPaymentTypes"
          [style]="{width: '50rem'}"
          [closable]="true"
          [resizable]="false"
          [draggable]="false">
  <div class="flex flex-column align-self-stretch mt-2">
    <p-table [value]="paymentMethodPaymentTypes"
             [selectionMode]="'single'"
             [(selection)]="selectedPaymentType"
             (onRowSelect)="onPaymentTypeClick($event)"
             [scrollable]="true"
             scrollHeight="20rem">
      <ng-template pTemplate="header">
        <tr>
          <th class="large-icon-cell force-size"></th>
          <th>{{ i18n?.i18nLng()['PAYMENTTYPES'] }}</th>
          <th>{{ i18n?.i18nLng()['STATUS'] }}</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-pt>
        <tr [pSelectableRow]="pt">
          <td class="large-icon-cell force-size">
            @if (pt.customIcon) {
              <sps-custom-icon [name]="pt.icon" [alt]="i18n.i18nLng()[pt.paymentMethod]" [size]="21"></sps-custom-icon>
            } @else {
              <i [ngClass]="pt.paymentMethod | keyToIcon"></i>
            }
          </td>
          <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
            {{ pt.title }}
          </td>
          <td>
            <sps-payment-status-tag [status]="pt.status"></sps-payment-status-tag>
          </td>
          <td class="table-toggler-icon align-items-center" style="width: 28px">
            <i class="pi pi-chevron-right"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template #footer class="pt-3">
    <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="showPaymentTypes = false"/>
  </ng-template>
</p-dialog>
<p-card [header]="i18n?.i18nLng()['PAYMENTMETHODS']" class="h-full">
  @if (!hasActivePaymentMethods) {
    <db-no-data-info i18nMessageKey="NOPAYMENTTYPESDATA"></db-no-data-info>
  } @else {
    <div class="payment-list">
      @for (paymentItem of paymentDataService.paymentMethods; track paymentItem) {
        @if (paymentItem.hasPaymentTypes) {
          <sps-payment-method-list-item [paymentListItem]="paymentItem" (itemClicked)="onPaymentMethodClick($event)"></sps-payment-method-list-item>
        }
      }
    </div>
  }
</p-card>
